module.exports = __webpack_public_path__ + "img/slider_galery_9.2488fb66.jpg";